export const blockNavigation = (msg, component) => {
  return {
    type: "BLOCK_NAVIGATION_BLOCK",
    msg,
    component
  }
}

export const unblockNavigation = (shouldUnblock = true) => {
  return {
    type: "BLOCK_NAVIGATION_UNBLOCK",
    shouldUnblock
  }
}

export const triggerBlockConfirmation = (unblocker) => {
  return {
    type: "BLOCK_NAVIGATION_TRIGGER_CONFIRM",
    unblocker
  }
}

export const updateComponent = (component) => {
  return {
    type: "BLOCK_NAVIGATION_UPDATE_COMPONENT",
    component
  }
}

export default {
  block: blockNavigation,
  unblock: unblockNavigation,
  trigger: triggerBlockConfirmation,
  update: updateComponent
}
